<div class="leave-message-modal">
  @if (leaveMessageStep() === "input") {
    <textarea
      class="message-input"
      [(ngModel)]="leaveMessageText"
      [placeholder]="'LEAVE_MESSAGE.PLACEHOLDER' | translate"
      [maxlength]="300"
      (input)="onMessageChange($event)"
      (keydown.enter)="onMessageEnter($event)">
    </textarea>

    <button class="submit-button" type="button" [disabled]="!leaveMessageText.trim() || isSubmitting" (click)="onSubmitMessage()">
      {{ 'BTN.OK' | translate }}
    </button>
  }

  @if (leaveMessageStep() === "error") {
    <div class="message-state">
      <img class="state-icon failed-icon" src="assets/icon/chat-failed-circle.svg">
      <img class="state-icon failed-x" src="assets/icon/chat-failed-x.svg">
      <div class="state-divider"></div>
      <p>{{ 'LEAVE_MESSAGE.ERROR' | translate }}</p>
      <button class="submit-button" type="button" (click)="onRetryMessage()">{{ 'LEAVE_MESSAGE.RETRY' | translate }}</button>
    </div>
  }

  @if (leaveMessageStep() === "invalid") {
    <div class="message-state">
      <ion-icon class="warning-icon" name="warning"></ion-icon>
      <div class="state-divider"></div>
      <p>{{ 'LEAVE_MESSAGE.INVALID_CHARS' | translate }}</p>
      <button class="submit-button" type="button" (click)="onBackToInput()">{{ 'LEAVE_MESSAGE.BACK' | translate }}</button>
    </div>
  }
</div>
